// extracted by mini-css-extract-plugin
module.exports = {"item":"_59989ee4","header":"_0b2ebb69","leftheader":"ae7987ab","right":"_7af2347d","title":"_0ba2b673","textcontainer":"_1166cc2a","text":"_89085530","itemNr":"f6b1a593"};